import React, { ReactNode } from 'react';
import { Col, Row } from 'antd';

import { Title } from '@/components/Typography';

interface HeaderProps {
	children: ReactNode;
}

export function Header({ children }: Readonly<HeaderProps>) {
	return (
		<Row justify="center">
			<Col>
				<Title level={3}>{children}</Title>
			</Col>
		</Row>
	);
}
